/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Fork_Copy_SuffixInputs */

const cs_templates_fork_copy_suffix = /** @type {(inputs: Templates_Fork_Copy_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(kopie)`)
};

const en_templates_fork_copy_suffix = /** @type {(inputs: Templates_Fork_Copy_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(copy)`)
};

/**
* | output |
* | --- |
* | "(copy)" |
*
* @param {Templates_Fork_Copy_SuffixInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_fork_copy_suffix = /** @type {((inputs?: Templates_Fork_Copy_SuffixInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Fork_Copy_SuffixInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_fork_copy_suffix(inputs)
	return cs_templates_fork_copy_suffix(inputs)
});